import {useRouter} from 'vue-router';

/**
 * Links inside `v-html` content are plain anchors, so clicking an internal one would reload the app.
 * Bind `onInternalLinkClick` with `@click` on the `v-html` element to route same-origin links via vue-router.
 */
export function useInternalLinks() {
  const router = useRouter();

  const onInternalLinkClick = (e: MouseEvent) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
      return;
    }
    const anchor = (e.target as HTMLElement).closest?.('a');
    if (!anchor || !anchor.getAttribute('href')) return;
    if ((anchor.target && anchor.target !== '_self') || anchor.hasAttribute('download')) return;

    const url = new URL(anchor.href, window.location.href);
    if (url.origin !== window.location.origin) return;

    e.preventDefault();
    router.push(url.pathname + url.search + url.hash);
  };

  return {onInternalLinkClick};
}
